export default function AboutAuthor() {
  const stats = [
    { icon: 'ri-calendar-check-line', value: '18+', label: 'лет практики' },
    { icon: 'ri-building-2-line', value: '100+', label: 'корпоративных проектов' },
    { icon: 'ri-presentation-line', value: '450+', label: 'тренингов' },
    { icon: 'ri-user-star-line', value: '4500+', label: 'участников' },
  ];

  const expertiseItems = [
    'Более 18 лет в продажах и переговорах',
    'Разработал авторскую методику холодных звонков с конверсией выше рынка',
    'Лично провёл тысячи холодных звонков в B2B и B2C',
    'Обучил более 4 500 менеджеров по продажам',
    'Работает с компаниями из Беларуси, России, Казахстана и других стран',
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50" id="trainer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-5 gap-10 items-center">
          <div className="lg:col-span-2">
            <div className="relative">
              <div className="w-full aspect-[3/4] rounded-2xl overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/045fa1b133efd9567759baab28602a6d/d5f5f47c7d94e3dc67c5ef073553230f.jpeg"
                  alt="Алексей Сивко — бизнес-тренер по холодным звонкам"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute bottom-4 left-4 right-4 bg-white/90 backdrop-blur-md rounded-xl p-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-star-fill text-white text-sm"></i>
                  </div>
                  <div>
                    <div className="text-lg font-bold text-gray-900">9,09 / 10</div>
                    <div className="text-xs text-gray-600">средняя оценка участников</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Кто проводит тренинг
            </h2>
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              <strong>Алексей Сивко</strong> — бизнес-тренер, эксперт в области телефонных продаж и холодных звонков. Более 18 лет практического опыта: от рядового менеджера по продажам до руководителя отдела и бизнес-тренера международного уровня.
            </p>
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              Алексей не теоретик — он лично совершил тысячи холодных звонков и знает, с какими трудностями сталкиваются менеджеры. Именно поэтому его тренинги построены на реальных кейсах, а не на оторванных от жизни методиках.
            </p>

            <div className="space-y-3 mb-8">
              {expertiseItems.map((item, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="w-5 h-5 bg-orange-500/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-orange-500 text-xs"></i>
                  </div>
                  <span className="text-sm text-gray-700 leading-relaxed">{item}</span>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4 mb-8">
              {stats.map((s, i) => (
                <div key={i} className="bg-white rounded-xl p-4 text-center border border-gray-100">
                  <div className="text-xl md:text-2xl font-extrabold text-orange-500 mb-1">{s.value}</div>
                  <div className="text-xs text-gray-500 leading-tight">{s.label}</div>
                </div>
              ))}
            </div>

            <a
              href="https://sivko.by/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-orange-500 font-semibold hover:text-orange-600 transition-colors cursor-pointer"
            >
              Подробнее на sivko.by
              <i className="ri-external-link-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}